import { Component, Prop, Vue, Emit } from 'vue-property-decorator'; 
import AlertEventBus, { IAlert } from 'Events/AlertEventBus';
import AlertComponent from './AlertComponent'; 
 

export const name = 'alert-success-component';

@Component({ 
    template: '#alert-success-component-template', 
    components: {
        AlertComponent
    }
    //name: 'delivery-address' 
}) 
export default class AlertSuccessComponent extends AlertComponent { 
 
    created() { 
        this.useTimeout = false; //we could add a prop to manipulate the timer
        this.type = name;
        var self = this; 
    } 
} 
 
Vue.component('alert-success-component', AlertSuccessComponent);